import React from 'react';

const Logout = () => {
  // Remove the accessToken from localStorage
  localStorage.removeItem('accessToken');

  // Reload the page
  window.location.reload();

  return null; // This component doesn't need to render anything
};

export default Logout;
